{
  "version": 1,
  "asset_id": "488ba761-b2ac-4a91-a0b2-e43078ceb9a4",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/488ba761-b2ac-4a91-a0b2-e43078ceb9a4/man2.jpg",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/488ba761-b2ac-4a91-a0b2-e43078ceb9a4/man2.jpg",
  "original_filename": "man2.jpg",
  "size": 202397,
  "content_type": "image/jpeg",
  "created_at": "2026-07-28T15:10:31Z"
}
